import { render, staticRenderFns } from "./OperacionesViewComentarios.vue?vue&type=template&id=44c573e1&"
import script from "./OperacionesViewComentarios.vue?vue&type=script&lang=js&"
export * from "./OperacionesViewComentarios.vue?vue&type=script&lang=js&"
import style0 from "./OperacionesViewComentarios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports